import type { ResultOf } from '@graphql-typed-document-node/core';

import { EMPTY_ID } from '@e-socna/empty-client';
import { graphql } from '@e-socna/data-layer';

import { useGraphQLQuery } from '../../../hooks/useGraphQLQuery.hook';

export const PersonPage_OnePerson_QueryDocument = graphql(`
  query PersonPage_OnePerson_Query($id: Id!) {
    findOnePerson(id: $id) {
      _id
      code
      isInternal
      fullName
      ...PersonPage_Tabs_Person_Fragment
      ...ActorCardCmp_Person_Fragment
    }
  }
`);

export type PersonPage_OnePerson = ResultOf<
  typeof PersonPage_OnePerson_QueryDocument
>['findOnePerson'];

export const useFindOnePersonQuery = (id = EMPTY_ID) =>
  useGraphQLQuery(
    PersonPage_OnePerson_QueryDocument,
    { id },
    { enabled: !!id },
  );
